import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=2e5faa90&scoped=true&"
import script from "./MenuButton.vue?vue&type=script&lang=ts&"
export * from "./MenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=2e5faa90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5faa90",
  null
  
)

export default component.exports